// @ts-check
import React from 'react'
import MdcAppLoader from '@/components/MdcAppLoader'

/**
 * @typedef {Object} ButtonProps
 * @property {'primary' | 'secondary'} [variant='primary'] Button variant
 * @property {'sm' | 'md' | 'lg'} [size='md'] Button size
 * @property {boolean} [disabled=false] Whether the button is disabled
 * @property {React.ReactNode} children Button content
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} [onClick] Click handler
 * @property {'button' | 'submit' | 'reset'} [type='button'] Button type
 * @property {string} [className=''] Additional class name
 * @property {boolean} [loading=false] Whether the button is in loading state
 * @property {string} [color] Button color (e.g., 'red')
 */

/**
 * Reusable Button component
 *
 * @param {ButtonProps} props Component props
 * @returns {React.ReactElement} Button component
 */
const Button = ({
  variant = 'primary',
  size = 'md',
  disabled = false,
  children,
  onClick,
  type = 'button',
  className = '',
  loading = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      className={`mdc-button mdc-button--${variant} mdc-button--size-${size} ${className}`}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className="mdc-button__label">
        {loading ? <MdcAppLoader padding={0} size={16} display="inline" /> : children}
      </span>
    </button>
  )
}

export default Button
